module.exports = __webpack_public_path__ + "img/蓝莓3.e64a49ca.png";